import { useApiPaginatedList } from "@/queries/base/useApiPaginatedList";

/**
 * Fetches a paginated list of notifications.
 * GET /notification?paginate=true&page={page}&perPage={perPage}
 *
 * @param {object} queryParams - Query parameters (user_role, notifiable_id, etc.)
 * @param {number} page - Current page number.
 * @param {number} perPage - Items per page.
 * @param {any} deps - Additional dependencies that trigger a refetch when changed.
 * @returns {{ data: object, isLoading: boolean, isFetching: boolean, error: string|null, refetch: Function }}
 *
 * The returned `data` shape is the raw API response:
 *   { success: true, message: "...", data: { data: [...], meta: { current_page, last_page, per_page, total } } }
 */
export function useNotifications(queryParams = {}, page = 1, perPage = 10, deps = []) {
  const cleanParams = Object.fromEntries(
    Object.entries(queryParams).filter(
      ([, v]) => v !== undefined && v !== null && v !== "",
    ),
  );
  const queryString = new URLSearchParams({
    ...cleanParams,
    paginate: "true",
    page: String(page),
    perPage: String(perPage),
  }).toString();
  const resourcePath = `/notification?${queryString}`;

  return useApiPaginatedList(resourcePath, [deps, JSON.stringify(queryParams), page, perPage]);
}
